// Name-addressable icons (task types, view types, field types are stored by name).
import {
  Activity,
  AlarmClock,
  AlignLeft,
  Archive,
  ArrowRight,
  AtSign,
  Bell,
  Bolt,
  Book,
  BookOpen,
  Bot,
  Briefcase,
  Bug,
  Building2,
  Calendar,
  CalendarCheck,
  CalendarClock,
  CalendarDays,
  CalendarPlus,
  CalendarSync,
  Camera,
  ChartGantt,
  ChartPie,
  Check,
  CheckSquare,
  CircleCheck,
  CircleDot,
  Clapperboard,
  Clipboard,
  Code,
  Coffee,
  Crown,
  Diamond,
  DollarSign,
  FileText,
  Flag,
  Flame,
  Folder,
  Gem,
  Gift,
  Globe,
  GraduationCap,
  Hash,
  Heart,
  Hourglass,
  Image,
  Inbox,
  Layers,
  Lightbulb,
  Link,
  List,
  ListChecks,
  ListTodo,
  Mail,
  Map,
  Megaphone,
  MessageSquare,
  Mic,
  Music,
  Package,
  Palette,
  PenTool,
  Phone,
  Rocket,
  Shapes,
  Sheet,
  Shield,
  ShoppingCart,
  Sparkles,
  SquareKanban,
  Star,
  Tag,
  Target,
  Timer,
  Trophy,
  Truck,
  Type,
  User,
  UserPlus,
  UserRound,
  Users,
  Video,
  Wrench,
  Zap,
  Hash as HashIcon,
  type IconComponent,
  type IconProps,
  ToggleLeft,
  Star as StarIcon,
  Percent,
  TextCursorInput,
  ChevronDownSquare,
  Tags,
} from '@/components/ui/icons';

export const ICONS: Record<string, IconComponent> = {
  Activity,
  AlarmClock,
  AlignLeft,
  Archive,
  ArrowRight,
  AtSign,
  Bell,
  Bolt,
  Book,
  BookOpen,
  Bot,
  Briefcase,
  Bug,
  Building2,
  Calendar,
  CalendarCheck,
  CalendarClock,
  CalendarDays,
  CalendarPlus,
  CalendarSync,
  Camera,
  ChartGantt,
  ChartPie,
  Check,
  CheckSquare,
  CircleCheck,
  CircleDot,
  Clapperboard,
  Clipboard,
  Code,
  Coffee,
  Crown,
  Diamond,
  DollarSign,
  FileText,
  Flag,
  Flame,
  Folder,
  Gem,
  Gift,
  Globe,
  GraduationCap,
  Hash,
  Heart,
  Hourglass,
  Image,
  Inbox,
  Layers,
  Lightbulb,
  Link,
  List,
  ListChecks,
  ListTodo,
  Mail,
  Map,
  Megaphone,
  MessageSquare,
  Mic,
  Music,
  Package,
  Palette,
  PenTool,
  Phone,
  Rocket,
  Shapes,
  Sheet,
  Shield,
  ShoppingCart,
  Sparkles,
  SquareKanban,
  Star,
  Tag,
  Target,
  Timer,
  Trophy,
  Truck,
  Type,
  User,
  UserPlus,
  UserRound,
  Users,
  Video,
  Wrench,
  Zap,
};

/** Icons offered when choosing a task type icon. */
export const TASK_TYPE_ICONS = [
  'CircleDot', 'Diamond', 'Megaphone', 'Clapperboard', 'Lightbulb', 'Bug', 'Rocket', 'Target', 'Flag', 'Star',
  'Zap', 'Flame', 'Heart', 'Trophy', 'Gem', 'Package', 'Truck', 'Briefcase', 'Building2', 'Book', 'FileText',
  'Image', 'Video', 'Camera', 'Music', 'Mic', 'Palette', 'PenTool', 'Code', 'Wrench', 'Shield', 'Globe', 'Map',
  'Mail', 'Phone', 'MessageSquare', 'Users', 'User', 'GraduationCap', 'Coffee', 'Gift', 'ShoppingCart', 'DollarSign',
  'ChartPie', 'Layers', 'ListChecks', 'Clipboard', 'Bot', 'Sparkles', 'Crown',
];

export const FIELD_TYPE_ICONS: Record<string, IconComponent> = {
  text: TextCursorInput,
  textarea: AlignLeft,
  number: HashIcon,
  money: DollarSign,
  dropdown: ChevronDownSquare,
  labels: Tags,
  date: Calendar,
  checkbox: ToggleLeft,
  people: Users,
  url: Link,
  email: Mail,
  phone: Phone,
  rating: StarIcon,
  progress: Percent,
};

export function Icon({ name, ...props }: { name: string | null | undefined } & IconProps) {
  const C = (name && ICONS[name]) || CircleDot;
  return <C {...props} />;
}
